export default "__VITE_ASSET__hRsgySS7__"